export default __webpack_public_path__ + "static/media/full-circle.9252d106.svg";